// removed by extract-text-webpack-plugin
module.exports = {"productionTitle":"_2IGfXSbu2AQE6Lz89CrTNb","productionSection":"BRGzb0bb_d0HZUwuJ4qMy","expandable":"_1aOizzPKaX0PHJ4w_W1-63","expanded":"_3bhcf9S2X9gbfLvKkmySzp","expand":"_12vxVrgrCpB5te0C9HV0YZ","products":"_2Q9Td1uRanh9Rk6aCE6XDE","count":"FoVpBMBMPROYH43k7ZvoE","productionRow":"_2JcmMW3vSTZ5ofewAFmJ47","invoiceId":"_2qDsSssuRUdEyI3PudiSm9","productionExport":"DgWTi_ZjdDjAjkx1Vk4IV"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/ProductionQueue/widget.scss
// module id = 1273
// module chunks = 0